import {Directive, ElementRef, Input, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[jdCustomControlOutlet]'
})
export class CustomControlOutletDirective {

  @Input() jdCustomControlOutlet: string;

  constructor(public viewContainerRef: ViewContainerRef,
              public elementRef: ElementRef) { }

}
